webpackJsonp([230064834116715],{

/***/ 592:
/***/ (function(module, exports) {

	module.exports = {"data":{"page":{"id":"/opt/build/repo/content/pages/2--starters/index.md absPath of file >>> MarkdownRemark","html":"","frontmatter":{"title":"I am Batman"}},"footnote":{"id":"/opt/build/repo/content/parts/footnote.md absPath of file >>> MarkdownRemark","html":""}},"pathContext":{"slug":"/starters/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---starters-6c56375612cdb74129ed.js